import styled from 'styled-components';
export const Select = styled.select`
  background-color: #ea6926;
  border: none;
  color: white;
`;
